import { contactUsConstants } from '../constants';
import { contactUsService } from '../../services';

export const contactUsActions = {
	contactUs,
	clear,
};

function contactUs(name, email, subject, body) {
	return (dispatch) => {
		dispatch(request());

		contactUsService
			.contactUs(name, email, subject, body)
			.then(
				(response) => {
						response.json().then(resp => {
						if (response.ok === true) {
							dispatch(success(resp));
										}
				 else {
						dispatch(failure(resp.error));
					}
				})
			}
				,
				(error) => {
					dispatch(failure(error));
				}
			)
			
	};

	function request() {
		return { type: contactUsConstants.CONTACTUS_REQUEST };
	}
	function success(response) {
		return { type: contactUsConstants.CONTACTUS_SUCCESS };
	}
	function failure(err) {
		return { type: contactUsConstants.CONTACTUS_FAILURE, err };
	}
}
function clear() {
	return { type: contactUsConstants.CONTACTUS_CLEAR };
}



// WEBPACK FOOTER //
// ./src/store/actions/constactUs.actions.js